module.exports = "https://static.energy5.com/_next/static/images/custom-f67d43f688fb042ccb6159f83d0c54f4.png";